import {OPEN, set} from '@acng/frontend-bounty/dom/attribute.js';
import {find} from '@acng/frontend-bounty/dom/document.js';
import {toggle} from '@acng/frontend-bounty/style/element.js';
import {AttributeLink} from '@acng/frontend-stargazer';

import {CLICK, on} from '@acng/frontend-bounty/dom/event.js';
import {closeAll} from '../service/auto-close.js';
import {STYLE_OPEN, swapClass} from '../service/style.js';
import {isHTMLElement} from '@acng/frontend-bounty/dom/type.js';
import {DETAILS} from '@acng/frontend-bounty/dom/element.js';
import {debug} from '@acng/frontend-bounty/dom/debug.js';

/**
 * @group DOM Attribute
 */
const attributeName = 'onclick-toggle-menu';

AttributeLink(attributeName, (element, value) => {
  on(element, CLICK, () => {
    const target = find(value);

    if (!target) {
      return;
    }

    DEBUG: if (debug(element)) console.log('toggle', {element, target});
    closeAll(target, true);

    if (isHTMLElement(target, DETAILS)) {
      set(target, OPEN, '');
    } else {
      swapClass(target, STYLE_OPEN, toggle(target, STYLE_OPEN));
    }
  });
});

export {attributeName as ONCLICK_TOGGLE_MENU};
